import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';

import useUIStore from '@/stores/pure/UIStore';

import frontPluginRouter from '../../routers/frontPluginRouter';

function FrontPluginBase() {
  const setColorTheme = useUIStore((state) => state.setColorMode);
  useEffect(() => {
    setColorTheme('light');
  }, []);
  return <RouterProvider router={frontPluginRouter} />;
}

export default FrontPluginBase;
